import React, { FC, useRef, useEffect } from "react"
import { useCreation } from "ahooks"
import ReactEcharts from "echarts-for-react"
import { EChartOption } from "echarts"
import Env from "@util/env"

type IMorePieProps = {
  data: { name: string; value: number }[]
  color?: string[]
  invisibleColor?: string[]
}

const MorePie: FC<IMorePieProps> = ({
  data,
  color = ["rgba(244, 97, 122, 1)", "rgba(115, 176, 254, 1)"],
  invisibleColor = ["rgba(244, 97, 122, 0.2)", "rgba(115, 176, 254, 0.2)"],
}) => {
  const ref = useRef()
  const options = useCreation<EChartOption>(() => {
    const series: EChartOption.Series[] = data.map((d, index) => {
      return {
        name: d.name,
        type: "pie",
        startAngle: 90,
        clockWise: false,
        radius: ["50%", "70%"],
        // clockwise: true,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        itemStyle: {
          color: color[index],
          shadowColor: color[index],
          shadowBlur: 0,
        },
        hoverAnimation: false,
        center: [(100 / data.length / 2) * (index * 2 + 1) + "%", "50%"],
        data: [
          {
            value: d.value,
            label: {
              formatter: "{a}\n{d}%",
              position: "center",
              show: true,
              textStyle: {
                fontSize: 14 * Env.getScale(),
                fontWeight: 500,
                lineHeight: 20 * Env.getScale(),
                color: color[index],
              },
            },
          },
          {
            value: 1 - d.value,
            name: "invisible",
            itemStyle: {
              color: invisibleColor[index],
            },
            emphasis: {
              color: invisibleColor[index],
            },
          },
        ],
      }
    })

    const options: EChartOption = {
      series,
    }

    return options
  }, [data])
  useEffect(() => {
    return () => {
      // @ts-ignore
      ref.current && ref.current.getEchartsInstance().dispose()
    }
  }, [ref])
  return (
    <div className="ct-pie-more" style={{ height: "100%" }}>
      {/* <Echart option={options || {}} /> */}
      <ReactEcharts
        ref={ref}
        option={options || {}}
        notMerge={true}
        lazyUpdate={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  )
}

export default MorePie
